var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      class: _vm.colorTheme,
      style: _vm.paddingStyle,
    },
    [
      _vm.showLayout
        ? [
            _c(
              "div",
              { staticClass: "container", class: _vm.isUseLoadMoreBtn },
              [
                _c("div", { staticClass: "container__body" }, [
                  _vm.title
                    ? _c("h5", { staticClass: "container__title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "container__cards container__cards--column-4",
                      attrs: { "data-column-count": "4" },
                    },
                    _vm._l(_vm.courseList, function (course) {
                      return _c(
                        "li",
                        {
                          key: course.id,
                          staticClass: "container__card",
                          attrs: { "data-id": course.itemId },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "card__container",
                              class:
                                _vm.isPreviewMode && !course.slug
                                  ? "card__error"
                                  : "",
                              attrs: {
                                href: "/" + course.slug,
                                target: _vm.isUseNewTab,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "card__body" },
                                [
                                  course.imageBadge
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "card__badge",
                                            style: _vm.imageBadgeStyle(course),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                style: _vm.innerBadgeStyle(
                                                  course.badgeBackgroundColor
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(course.imageBadge) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "card__image",
                                    style: _vm.backgroundImageStyle(
                                      course.desktopCardAsset
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "card__labels" },
                                    _vm._l(
                                      course.keywords,
                                      function (badge, index) {
                                        return _c("li", { key: index }, [
                                          _vm._v(_vm._s(badge)),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card__text" }, [
                                    _c(
                                      "strong",
                                      { staticClass: "card__title text--h6" },
                                      [_vm._v(_vm._s(course.publicTitle))]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "card__content" }, [
                                      _vm._v(_vm._s(course.publicDescription)),
                                    ]),
                                  ]),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container__footer" }, [
                  _c("div", { staticClass: "container__btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "container__load-more-btn",
                        style: _vm.loadMoreBtnStyle,
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.loadMoreBtnText) +
                            "\n            "
                        ),
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "7",
                              viewBox: "0 0 12 7",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M11 1L6 6L1 1",
                                stroke: _vm.buttonColor,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm.showWarningMessage
        ? [
            _c("h2", { staticClass: "container__error" }, [
              _vm._v("courseId를 잘못 입력하였습니다. 확인해주세요."),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }